import { render, staticRenderFns } from "./SearchResultCompetition.vue?vue&type=template&id=9663735a&scoped=true"
import script from "./SearchResultCompetition.vue?vue&type=script&lang=js"
export * from "./SearchResultCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9663735a",
  null
  
)

export default component.exports